<template>
  <div>
    <div class="lke-top">
      <i class="el-icon-chat-line-square"></i>
      发布个人评论或心得
    </div>
    <el-input
      type="textarea"
      :autosize="{ minRows: 2, maxRows: 4 }"
      placeholder="请输入内容"
      v-model="value"
    >
    </el-input>
    <div class="lke-fot">
      <div class="lke-fot-l">
        <span>还可以输入{{ 180 - value.length }}字</span>
      </div>
      <div class="lke-fot-r">
        <span>发布</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getcomment } from "@/api/learnspace";
export default {
  name: "fbpl",
  props: {
    coursedetailsId: String,
    courseId: String,
  },
  data() {
    return {
      value: "",
      fileList: [],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style>
</style>

<style scoped>
.lke-top {
  padding: 10px 0;
  color: #2890f4;
  font-weight: bold;
}
.lke-top > i {
  font-size: 20px;
  padding-right: 5px;
}
.lke-fot {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}
.lke-fot-l > span {
  font-size: 12px;
}
.lke-fot-r {
  padding: 10px;
}
.lke-fot-r > span {
  color: #2890f4;
  cursor: pointer;
  font-weight: bold;
  letter-spacing: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/components/fbpl.vue